module.exports = __webpack_public_path__ + "static/media/kartuloveas.61a21020.png";